// Group only the announcement sections, leaving the sticky header independent.
(() => {
  function groupAnnouncements() {
    const header = document.getElementById('header-group');
    if (!header) return;
    const top = header.querySelector('.announcement-bar--single-line:not(.announcement-bar--static)')?.closest('.shopify-section');
    const bottom = header.querySelector('.announcement-bar--static')?.closest('.shopify-section');
    if (!top || !bottom || top === bottom) return;
    let group = header.querySelector('.announcement-bars-group');
    if (!group) {
      group = document.createElement('div');
      group.className = 'announcement-bars-group';
      top.before(group);
    }
    if (top.parentElement !== group) group.prepend(top);
    if (bottom.parentElement !== group) group.append(bottom);
  }
  groupAnnouncements();
  document.addEventListener('shopify:section:load', groupAnnouncements);
  document.addEventListener('shopify:section:reorder', groupAnnouncements);
})();
